import { defineStore } from 'pinia'
import { showError } from '@/common/functions'
import { DisclaimerService, DisclaimerTemplateService } from '@/services/index.js'

export const useDisclaimerStore = defineStore('disclaimerStore', {
  state: () => ({
    templates: [],
    disclaimers: [],
    loading: false,
  }),

  actions: {
    async fetchTemplates() {
      try {
        this.loading = true
        const { status, data } = await DisclaimerTemplateService.list()
        if (status === 200 && data) {
          this.templates = data
        }
      } catch (e) {
        showError('Failed to fetch disclaimer templates', e.message)
        console.error('🚨 Failed to fetch disclaimer templates:', e)
      } finally {
        this.loading = false
      }
    },

    async fetchDisclaimers() {
      try {
        this.loading = true
        const { status, data } = await DisclaimerService.list()
        if (status === 200 && data) {
          this.disclaimers = data
        }
      } catch (e) {
        showError('Failed to fetch disclaimers', e.message)
        console.error('🚨 Failed to fetch disclaimers:', e)
      } finally {
        this.loading = false
      }
    },
  },
})
